module.exports = __webpack_public_path__ + "img/SierraChartLogo.ee452688.png";